__webpack_require__.p = "/Bit-coin-react/";